import { createApp } from 'vue'
import App from './App.vue'
import { ModuleRegistry } from 'ag-grid-community';
import { AllCommunityModule } from 'ag-grid-community';
import './registerServiceWorker'

// Registrar todos os módulos da comunidade
ModuleRegistry.registerModules([AllCommunityModule]);

createApp(App).mount('#app')
